import { useState, useEffect } from "react";
import { http } from "./api";

/**
 * Memorial / peringatan pendiri (TAKY). Fetches the public memorial config once
 * and caches it module-wide so AppShell, Login and Settings share one source.
 * When active (tanggal 24 Okt atau di-force super admin), the app shows a dark
 * blue accent + "TAKY Money Changer" near the logo.
 */
let cache = null;
const subs = new Set();

export async function refreshMemorial() {
  try {
    const { data } = await http.get("/public/memorial");
    cache = data;
    subs.forEach((fn) => fn(data));
    return data;
  } catch {
    return cache;
  }
}

export function useMemorial() {
  const [m, setM] = useState(cache);
  useEffect(() => {
    const fn = (d) => setM(d);
    subs.add(fn);
    if (cache) setM(cache);
    else refreshMemorial();
    return () => subs.delete(fn);
  }, []);
  return m;
}

export function MemorialRibbon({ m }) {
  if (!m?.active) return null;
  return (
    <div
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 px-4 py-2 text-center text-white"
      style={{ background: `linear-gradient(90deg, ${m.accent}, ${m.accent}cc)` }}
      data-testid="memorial-ribbon"
    >
      <span className="text-sm font-black tracking-tight">{m.label}</span>
      <span className="text-[11px] opacity-90">
        {m.note} — <span className="font-semibold">{m.founder}</span>
      </span>
      <span className="text-[10px] opacity-75">Lahir {m.born} · Wafat {m.died} — Al-Fatihah</span>
    </div>
  );
}
